var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('SideBar',{attrs:{"items":_vm.items,"header":{ logo: _vm.Logo, name: 'DWM', to: '/' },"support":{
        icon: _vm.Telegram,
        title: _vm.$i18n.t('support'),
        to: 'https://t.me/DT_ECOSYSTEM_SUPPORT',
      }}})]},proxy:true},{key:"main",fn:function(){return [(_vm.accessToView)?_c('RouterView'):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }